import $ from 'jquery';
import {
  favouritesPageRemoveButtonHandler,
  favouritesPageViewMoreButtonHandler
} from 'ts/pages/wishlist/wishlistUtils';
import initWishlistATB from './wishlistATB';
import wishlistToggleEmailForm from './wishlistToggleEmailForm';

$(() => {
  wishlistToggleEmailForm();
  $('#shareForm').parsley();
  initWishlistATB();
  favouritesPageRemoveButtonHandler();
  favouritesPageViewMoreButtonHandler();
  $('.product-list').removeClass('disabled');
});
